export default ({...props}) => {
  const {size} = props.theme
  return `
      width: ${size(12.5)}%;
      & div.calender-nav-header-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;

        & p {
          margin: 0;
          
          & .gap {
            display: inline-block;
            padding: 0px 8px;
          }
        }
      }
      
      @media screen and (max-width: 501px) {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
      }
    `
}
